/* eslint-disable replo/no-export-from */
import type { RenderComponentProps } from "replo-runtime/shared/types";
import type { Component } from "schemas/component";
import type { BundleConfig } from "schemas/generated/bundleDiscounts";

import React from "react";

import { ReploComponent } from "../ReploComponent";
import { BundleBuilderProvider } from "./BundleBuilderContext";

const getBundleBuilderProps = (props: Component["props"]) => {
  const bundleTargetType = (props.bundleTargetType ?? "products") as
    | "products"
    | "variants";
  const productsWithVariants = props.productsWithVariants ?? [];
  const bundleDiscountThresholds = props.bundleDiscountThresholds ?? [];
  const allowMultipleOfSameItem = Boolean(props.allowMultipleOfSameItem);
  const isTiered = Boolean(props.isTiered);
  return {
    bundleTargetType,
    productsWithVariants,
    bundleDiscountThresholds,
    allowMultipleOfSameItem,
    isTiered,
  };
};

const BundleBuilder = (props: RenderComponentProps) => {
  const { component, componentAttributes, context } = props;

  const {
    bundleTargetType,
    productsWithVariants,
    bundleDiscountThresholds,
    allowMultipleOfSameItem,
    isTiered,
  } = getBundleBuilderProps(component.props);

  const bundleConfig: BundleConfig = {
    id: component.id,
    targetType: bundleTargetType,
    thresholds: bundleDiscountThresholds,
    productsWithVariants,
    allowMultipleOfSameItem,
    isTiered,
  };

  return (
    <BundleBuilderProvider
      componentId={component.id}
      bundleConfig={bundleConfig}
      context={context}
    >
      <div
        {...componentAttributes}
        style={{
          display: "flex",
          gap: "20px",
          width: "100%",
          ...componentAttributes.style,
        }}
      >
        {component.children?.map((childComponent) => (
          <ReploComponent
            key={childComponent.id}
            component={childComponent}
            context={context}
          />
        ))}
      </div>
    </BundleBuilderProvider>
  );
};

// Export all the bundle components
export { AddToBundleButton } from "./components/AddToBundleButton";
export { AddToCartButton } from "./components/AddToCartButton";
export { BundleCart } from "./components/BundleCart";
export { BundleCartTotals } from "./components/BundleCartTotals";
export { BundleFooter } from "./components/BundleFooter";
export { BundleGrid } from "./components/BundleGrid";
export { BundleHeader } from "./components/BundleHeader";
export { BundleProgressBar } from "./components/BundleProgressBar";
export { BundleSummary } from "./components/BundleSummary";
export { BundleTierSelector } from "./components/BundleTierSelector";
export { ProductTile } from "./components/ProductTile";
export { BundleProductVariantSelector } from "./components/BundleProductVariantSelector";

// Export the default component
export default BundleBuilder;
